import { createContext, useContext, useEffect, useState } from "react";
import api, { setStoredClient } from "../lib/api";

const AuthContext = createContext(null);

const clearStorage = () => {
  localStorage.removeItem("cibs_token");
  localStorage.removeItem("cibs_user");
};

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("cibs_token");
    const cachedUser = localStorage.getItem("cibs_user");
    if (!token) {
      setLoading(false);
      return;
    }
    if (cachedUser) {
      try { setUser(JSON.parse(cachedUser)); } catch { /* ignore */ }
    }
    api.get("/auth/me")
      .then((r) => {
        setUser(r.data);
        localStorage.setItem("cibs_user", JSON.stringify(r.data));
        if (r.data.client) setStoredClient(r.data.client);
      })
      .catch(() => {
        clearStorage();
        setUser(null);
      })
      .finally(() => setLoading(false));
  }, []);

  const setSession = (data) => {
    localStorage.setItem("cibs_token", data.token);
    localStorage.setItem("cibs_user", JSON.stringify(data.user));
    if (data.user.client) setStoredClient(data.user.client);
    setUser(data.user);
    return data.user;
  };

  const login = async (email, password, clientCode) => {
    const { data } = await api.post("/auth/login", { email, password, client_code: clientCode || null });
    return setSession(data);
  };

  const clearSession = () => {
    clearStorage();
    setUser(null);
  };

  const logout = () => {
    const wasSuper = window.location.pathname.startsWith("/superadmin");
    clearStorage();
    setStoredClient(null);
    setUser(null);
    window.location.href = wasSuper ? "/superadmin/login" : "/";
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, setSession, clearSession }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
